/* ============================================
   ArtGold Favorites — Luxury Grid Engine
   ============================================ */

(function(){
  var STORAGE_KEY = 'ag_wishlist';
  var MAX_ITEMS = 50;

  function getFavorites() {
    try {
      var list = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      return list.filter(function(p){ return p && p.id && p.title; });
    } catch(e) { return []; }
  }

  function saveFavorites(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function toggleProduct(btn) {
    var id = parseInt(btn.getAttribute('data-ag-wishlist'));
    if (!id) return;
    var list = getFavorites();
    var idx = -1;
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === id) { idx = i; break; }
    }
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      if (list.length >= MAX_ITEMS) return;
      list.push({
        id: id,
        handle: btn.getAttribute('data-ag-wishlist-handle') || '',
        title: btn.getAttribute('data-ag-wishlist-title') || '',
        image: btn.getAttribute('data-ag-wishlist-image') || '',
        price: btn.getAttribute('data-ag-wishlist-price') || '',
        url: btn.getAttribute('data-ag-wishlist-url') || ''
      });
    }
    saveFavorites(list);
    refresh();
  }

  function removeProduct(id) {
    var list = getFavorites().filter(function(p){ return p.id !== id; });
    saveFavorites(list);
    refresh();
  }

  function refresh() {
    updateButtons();
    updateBadge();
    renderDrawer();
  }

  function updateButtons() {
    var list = getFavorites();
    var ids = {};
    list.forEach(function(p){ ids[p.id] = true; });
    document.querySelectorAll('[data-ag-wishlist]').forEach(function(btn){
      var id = parseInt(btn.getAttribute('data-ag-wishlist'));
      if (ids[id]) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
      } else {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-pressed', 'false');
      }
    });
  }

  function updateBadge() {
    var count = getFavorites().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function(el){
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function renderDrawer() {
    var items = getFavorites();
    var grid = document.getElementById('ag-fav-grid');
    var empty = document.getElementById('ag-fav-empty');
    var title = document.querySelector('.ag-fav-drawer__title');
    if (!grid) return;

    if (title) {
      title.textContent = 'My Favorites (' + items.length + ')';
    }

    if (items.length === 0) {
      grid.style.display = 'none';
      if (empty) empty.style.display = '';
      return;
    }

    if (empty) empty.style.display = 'none';
    grid.style.display = '';

    var html = '';
    for (var i = 0; i < items.length; i++) {
      var p = items[i];
      html +=
        '<div class="ag-fav-card">' +
          '<a href="' + esc(p.url) + '" class="ag-fav-card__image-wrap">' +
            '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">' +
          '</a>' +
          '<button class="ag-fav-card__remove" data-ag-fav-remove="' + p.id + '" aria-label="Remove">&times;</button>' +
          '<a href="' + esc(p.url) + '" class="ag-fav-card__title">' + esc(p.title) + '</a>' +
          '<div class="ag-fav-card__price">' + esc(p.price) + '</div>' +
        '</div>';
    }
    grid.innerHTML = html;
  }

  function openDrawer() {
    renderDrawer();
    var drawer = document.getElementById('ag-fav-drawer');
    var overlay = document.getElementById('ag-fav-overlay');
    if (drawer) {
      drawer.style.display = 'flex';
      drawer.offsetHeight;
      drawer.classList.add('is-open');
    }
    if (overlay) overlay.classList.add('is-open');
    document.body.classList.add('ag-wishlist-drawer-open');
  }

  function closeDrawer() {
    var drawer = document.getElementById('ag-fav-drawer');
    var overlay = document.getElementById('ag-fav-overlay');
    if (drawer) drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('ag-wishlist-drawer-open');
    setTimeout(function(){
      if (drawer) drawer.style.display = 'none';
    }, 400);
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-ag-wishlist-toggle]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-ag-wishlist]')) { e.preventDefault(); toggleProduct(e.target.closest('[data-ag-wishlist]')); return; }
    if (e.target.closest('[data-ag-fav-close]')) { e.preventDefault(); closeDrawer(); return; }
    if (e.target.id === 'ag-fav-overlay') { closeDrawer(); return; }
    var rm = e.target.closest('[data-ag-fav-remove]');
    if (rm) { e.preventDefault(); removeProduct(parseInt(rm.getAttribute('data-ag-fav-remove'))); }
  });

  // Clean ghosts + init
  saveFavorites(getFavorites());
  updateButtons();
  updateBadge();

  window.ArtGoldWishlist = {
    get: getFavorites,
    toggle: toggleProduct,
    remove: removeProduct,
    refresh: refresh,
    openDrawer: openDrawer,
    closeDrawer: closeDrawer
  };
})();
